import { styled } from "@mui/material/styles";
import TextareaAutosize from "react-autosize-textarea";
import * as React from "react";
import Dropdown from "../libraries/Dropdown";

export const Container = styled("div")({
  position: "relative",
  display: "flex",
  flexDirection: "row",
  height: "100%",
  overflow: "hidden",
});

export const RightPanel = styled("div")({
  width: "260px",
  background: "rgb(240, 240, 240)",
  borderLeft: "1px solid rgb(220, 220, 220)",
  // paddingLeft: "16px",
  // paddingRight: "16px",
  paddingBottom: "18px",
  overflowY: "scroll",
  height: "100%",
  transition: "all 0.5s",
});

export const Label = styled("div")({
  fontSize: "12px",
  marginTop: "10px",
  marginBottom: "0px",
  color: "rgb(120, 120, 120)",
  userSelect: "none",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
});

export const MultiLineInput = styled(TextareaAutosize)({
  outline: "none",
  border: "1px solid rgb(220, 220, 220)",
  width: "100%",
  fontSize: "12px",
  padding: "8px",
  color: "rgb(120, 120, 120)",
  resize: "none",
  marginBottom: "12px",

  "&:focus": {
    border: "1px solid rgb(180, 180, 180)",
  },
});

export const SingleLineInput = styled("input")({
  outline: "none",
  border: "1px solid rgb(220, 220, 220)",
  width: "100%",
  fontSize: "12px",
  padding: "8px",
  color: "rgb(120, 120, 120)",
  resize: "none",
  marginBottom: "12px",

  "&:focus": {
    border: "1px solid rgb(180, 180, 180)",
  },
});

export const ColorInputRow = styled("div")({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  justifyContent: "center",
  maxWidth: "200px",
});

export const ColorInputContainer = styled("div")({
  width: "20px",
  height: "20px",
  borderRadius: "4px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  margin: "2px",

  "&:hover": {
    background: "rgb(220, 220, 220)",
  },

  "&.selected": {
    background: "rgb(210, 210, 210)",
  },
});

export const ColorInputCircle = styled("div")({
  width: "15px",
  height: "15px",
  borderRadius: "50%",
  background: "#D3455B",
});

export function ColorInput(props: {
  color: string;
  selected?: boolean;
  onClick?: () => void;
}) {
  return (
    <ColorInputContainer
      className={props.selected ? "selected" : "null"}
      onClick={props.onClick}
    >
      <ColorInputCircle style={{ background: props.color }} />
    </ColorInputContainer>
  );
}

export const Toolbox = styled("div")({
  position: "absolute",
  left: 0,
  top: 0,
  width: "84px",
  height: "100%",
  overflowY: "hidden",
  paddingLeft: "24px",
  paddingTop: "24px",
  pointerEvents: "none",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
});

export const Tool = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: "50%",
  boxShadow: "0 1px 5px rgba(0, 0, 0, 0.15)",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  width: "48px",
  height: "48px",
  cursor: "pointer",
  transition: "all 150ms ease-in-out",
  color: "rgb(70, 70, 70)",
  background: "white",
  pointerEvents: "all",

  margintTop: "24px",
  marginBottom: "24px",
  userSelect: "none",

  "&:hover, &.selected": {
    transform: "scale(1.2)",
    border: "1px solid rgba(137, 70, 255, 0.5)",
  },
});

export const StyledDropdown = styled(Dropdown)({
  width: "100%",
  marginBottom: "12px",

  ".Dropdown-control": {
    color: "rgb(120, 120, 120)",
    fontSize: "12px",
    lineHeight: "16px",
    border: "1px solid rgb(220, 220, 220)",
    padding: "8px 10px",
    "&:focus": {
      border: "1px solid rgb(180, 180, 180)",
    },
  },

  ".Dropdown-option": {
    fontSize: "12px",
    lineHeight: "16px",
  },
});
